seedWebApp.controller('FtpController', ['$scope', '$uibModal', '$window', 'DocService', 'ToastService',
    function ($scope, $uibModal,$window, DocService, ToastService) {

        console.log('FtpController');

        $scope.getSettings = function () {
            //$scope.loadingTotal = true;
            DocService.getFtpSettings().then(function (response) {
                //$scope.loadingTotal = false;
                $scope.ftpSettings = response.data;
            });
        };

        $scope.getSettings();


        $scope.getFiles = function (folder) {
            $scope.error = null;
            var toastID = ToastService.createToast('Carregando...', '', 0, 'wait');
            $scope.loading = true;
            DocService.getFtpFiles(folder).then(function (response) {
                $scope.loading = false;
                $scope.ftpFiles = response.data;
                //ToastService.updateToast(toastID, 'Ok!','', 2000, 'success');
                ToastService.removeToast(toastID);
            },
                function (err) {
                    $scope.loading = false;
                    console.log('Error');
                    console.log(err);
                    $scope.error = err;
                    var errMsg = '';
                    if (err.data && err.data.ExceptionMessage) {
                        errMsg = err.data.ExceptionMessage;
                    }
                    ToastService.updateToast(toastID, 'Erro!', errMsg, 2000, 'error');
            });
        };

        $scope.doRefresh = function () {
            $scope.getFiles($scope.ftpSettings.FolderName);
        };


        $scope.getFiles();

        $scope.clickFile = function (file) {
            if (file.IsDirectory) {
                //$scope.lastFolder = $scope.ftpSettings.FolderName;
                $scope.ftpSettings.FolderName += '/' + file.Name;
                $scope.getFiles($scope.ftpSettings.FolderName);
            }
            else {
                //$scope.showPdf(file);
                $scope.getFile(file)
            }
        };

        $scope.clickFile2 = function (file) {
            //$window.open('localhost:xxx/api/document', '_blank');

            console.log('clickFile2');
            //https://localhost:44352/

            $window.open('../Api/Doc/GetFtpFile?filePath=' + file.AbsolutePath, '_blank');
        };

        //MOVER DOCSERVICE
        $scope.getFileExtension = function (fileName) {
            return DocService.getFileExtension(fileName);
            //if (fileName) {
            //    return fileName.split('.').pop().toUpperCase();
            //}
            //else {
            //    return 'xxx';
            //}
        };

        //MOVER DOCSERVICE
        //$scope.getFile = function (file) {
        //    console.log('getFile ' + file.AbsolutePath);
        //    $scope.error = null;
        //    var toastID = ToastService.createToast('Baixando arquivo...', file.Name, 0, 'wait');
        //    $scope.downloading = true;
        //    DocService.getFtpFile(file.AbsolutePath).then(function (result) {
        //        $scope.downloading = false;
        //        ToastService.removeToast(toastID);
        //        var fileType = "application/pdf";
        //        var fileExt = $scope.getFileExtension(file.Name);
        //        if (fileExt == 'PNG') {
        //            fileType = 'image/png'
        //        }
        //        else if (fileExt == 'JPG') {
        //            fileType = 'image/jpeg';
        //        }

        //        var blob = new Blob([result.data], { type: fileType });
        //        var objectUrl = URL.createObjectURL(blob);
        //        var fileName = file.Name;
        //        if (navigator.msSaveBlob) {
        //            return navigator.msSaveBlob(blob, fileName);
        //        }
        //        var pdf = document.createElement('a');
        //        pdf.href = objectUrl;

        //        /*
        //        //AQUI FAZ DOWNLOAD
        //        pdf.download = fileName;
        //        pdf.click();
        //        window.URL.revokeObjectURL(objectUrl);
        //        */
        //        //console.log(objectUrl);

        //        $window.open(objectUrl, '_blank');
        //    },
        //        function (err) {
        //            $scope.downloading = false;
        //            //console.log('Error');
        //            //console.log(err);
        //            $scope.error = err;
        //            var errMsg = '';
        //            if (err.data && err.data.ExceptionMessage) {
        //                errMsg = err.data.ExceptionMessage;
        //            }
        //            ToastService.updateToast(toastID, 'Erro!', errMsg, 2000, 'error');
        //        });
        //};

        $scope.getFile = function (file) {
            return DocService.showFile($scope, file.Name, file.AbsolutePath);
        };

        $scope.openNewTab = function (file) {
            var newUrl = file.FolderName;

            $window.open(newUrl, '_blank');
            //$scope.cancel();
        };

        $scope.showPdf = function (file) {
            var order = '';
            var doc = '';
            var modalInstance = $uibModal.open({
                templateUrl: 'SPA/orders/showPdfModal.html',
                controller: 'ShowPdfCtrl',
                size: 'xl',
                resolve: {
                    order: function () {
                        return order;
                    },
                    doc: function () {
                        return doc;
                    },
                    file: function () {
                        return file;
                    }
                }
            });
            modalInstance.result.then(function (selectedItem) { });
        };


        function RemoveLastDirectoryPartOf(the_url) {
            var the_arr = the_url.split('/');
            the_arr.pop();
            return (the_arr.join('/'));
        }

        $scope.levelUp = function () {
            if ($scope.ftpSettings.FolderName) {
                var url = $scope.ftpSettings.FolderName;
                //var upFolder = url.substring(0, url.lastIndexOf('/'));
                var upFolder = RemoveLastDirectoryPartOf(url);

                $scope.ftpSettings.FolderName = upFolder;
                $scope.getFiles($scope.ftpSettings.FolderName);
            }
        };
    }
]);
